import { useState, useCallback } from 'react';
import { renapoApi } from '../api/renapo.api';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { FaTriangleExclamation } from 'react-icons/fa6';

import toast from 'react-hot-toast';
export const useRenapo = () => {
  const [curp, setCurp] = useState(null);
  const [user, setUser] = useState(null);
  const getByCurp = useCallback(async () => {
    try {
      const response = await renapoApi.getByCurp(curp);
      if (response.exists) {
        toast('La curp ya se encuentra asociada a un usuario', {
          icon: <FaTriangleExclamation color="#F59E0B" size={20} />,
        });
      }
      if (!response.exists && !response.personData) {
        toast('La curp  no fue encontrada, verificala porfavor', {
          icon: <FaTriangleExclamation color="#F59E0B" size={20} />,
        });
      }
      setUser(response.personData);
      return response.personData;
    } catch (error) {
      setUser(null);
      toast.error(error?.message || TOAST_ERROR_IDS.ERROR_CONNECTING_TO_RENAPO);
      return null;
    }
  }, [curp]);

  const [dataTestSaved, setDataTestSaved] = useState();
  const testSaved = useCallback(async () => {
    try {
      await renapoApi.testSaved(dataTestSaved);
      toast.success(TOAST_SUCCESS_IDS.CORRECT_TEST_SAVED);
      //setUser(response);
    } catch (error) {
      toast.error(error?.message || TOAST_ERROR_IDS.ERROR_CONNECTING_TO_RENAPO);
    }
  }, [dataTestSaved]);

  const [ testingConfigActive, setTtestingConfigActive ] = useState(false);
  const testConfigActive = useCallback(async () => {
    try {
      setTtestingConfigActive(true);
      const response = await renapoApi.testConfigActive();
      toast.success(TOAST_SUCCESS_IDS.CORRECT_TEST_FROM_ACTIVE_CONFIGURATION, {
        id: TOAST_SUCCESS_IDS.CORRECT_TEST_FROM_ACTIVE_CONFIGURATION,
      });
    } catch (error) {
      toast.error(error?.message || TOAST_ERROR_IDS.ERROR_CONNECTING_TO_RENAPO);
    } finally {
      setTtestingConfigActive(false);
    }
  }, []);

  const [ testingThisConfig, setTestingThisConfig] = useState(false);
  const [isOkThisConfig,setIsOkThisConfig]=useState(false)
  const testThisConfig = useCallback(async (data) => {
    try {
     const response= await renapoApi.testThisConfig(data);
     if(!response?.success){
      toast.error(response?.message || TOAST_ERROR_IDS.ERROR_CONNECTING_TO_RENAPO);
      setIsOkThisConfig(false)

     }
     if(response?.success){
      toast.success(TOAST_SUCCESS_IDS.CORRECT_TEST_SAVED, {
        id: TOAST_SUCCESS_IDS.CORRECT_TEST_SAVED,
      });
            setIsOkThisConfig(true)

    }
    } catch (error) {
      toast.error(error?.message || TOAST_ERROR_IDS.ERROR_CONNECTING_TO_RENAPO);
    } finally {
      setTestingThisConfig(false);
    }
  }, []);
 
  const onChangeIsOkThisConfig=()=>{
    setIsOkThisConfig(false)
  }
  return {
    getByCurp,
    testSaved,
    curp,
    setCurp,
    dataTestSaved,
    setDataTestSaved,
    user,
    testConfigActive,
    testingConfigActive,
    testThisConfig,
    testingThisConfig,
    isOkThisConfig,onChangeIsOkThisConfig
  };
};
